module.exports = __webpack_public_path__ + "img/Sonda-Laser.f4d4bebf.svg";